import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgPaperPlane = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="m7.269 14.145-3.372-3.37a1.35 1.35 0 0 1-.37-1.23 1.38 1.38 0 0 1 .911-1.057l13.204-4.402a1.379 1.379 0 0 1 1.772 1.77l-4.406 13.195a1.38 1.38 0 0 1-.996.91 1.35 1.35 0 0 1-1.292-.369l-2.683-2.668-2.88 1.488zm0 0L19.02 4.357"
      />
    </svg>
  );
};
export default SvgPaperPlane;
